<template>
<div>
<!-- <div class="row">
  <div class="col-sm-1"> Society </div>
  <div class="col-sm-4"> <Vselect :options="societyoption" v-model="societyName"  searchable @change="societyName"/></div>
  
    <div class="col-sm-2"> Ownername </div>
  <div class="col-sm-4">  <Vselect :options="farmernamelist" v-model="ownerName"  searchable /></div>
</div>
<br> -->
<!-- <div class="row">
  <div class="col-sm-1"> Route</div>
  <div class="col-sm-4"> <Vselect :options="routenamelist" v-model="routeName"  searchable /></div>
  
    <div class="col-sm-2"> UnionName </div>
  <div class="col-sm-4">  <Vselect :options="unionnamelist" v-model="unionName"   searchable /></div>

  <div class="col-sm-1"> 
    <CButton color="info">
            GO
              </CButton>
  </div>
</div> -->
<br>

 <div class="md-layout-item md-size-100">
  




  <CDataTable
           :items="animalItem"
            :fields="fields"
            table-filter
            items-per-page-select
            :items-per-page="5"
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Breed"
          />
  <div class="ui-theme-settings" >
     <CButton
      type="button"
      class="btn-open-options btn btn-warning"
      v-bind:class="{ 'is-active' : isConfigOpen }"
      @click="toggleConfig('settings-open')"
    >
     <img src="img/cross.svg" class="svg" style="width:20px"  v-if="isConfigOpen" />
    <!-- <CIcon name="cilPencil" style="color:white"  v-if="isConfigOpen" ></CIcon> -->
      <!-- <md-icon style="color:white" v-if="isConfigOpen">arrow_forward</md-icon> -->
      <!-- <md-icon style="color:white" v-if="!isConfigOpen">arrow_back</md-icon> -->
      <img src="img/pencil.svg" class="svg" style="width:20px"  v-if="!isConfigOpen"/>
    </CButton>
    <div class="theme-settings__inner">
      <div class="md-layout" style="background-color:#425276;color: #fff;font: icon;">
       
        <div
          class="md-layout-item md-size-60"
          style="padding-left:0px !important;margin-top: auto;margin-bottom:auto;"
        >
          <!-- <span
            style="float:left;font-weight:400;text-transform: capitalize;"
          >{{this.user.firstName}} {{this.user.lastName}}</span> -->
          <br />
          <!-- <span style="font-size:13px;">Punched-in @ 09:35 am</span>
          <br />-->
          <!-- <span style="font-size:13px;">
            Madurai @ 09:35:00 am
          </span>-->
        </div>
        <div class="md-layout-item md-size-25" style="text-align: right;padding-right: 30px;">
          <!-- <img class="my-icon" style="width:40px;float:right;" src="/img/phone.svg" /> -->
          <md-icon style="color: #CFD8DC;font-size: 30px !important;">devices_other</md-icon>
        </div>
        <div class="md-layout-item md-size-100">
          <hr />
        </div>
        <!-- <div class="md-layout-item md-size-25" style="margin-bottom: 5px;">
          <radial-progress-bar
            :diameter="100"
            :completed-steps="completedSteps"
            :total-steps="totalSteps"
            :strokeWidth="3"
          >
            <p style="color:#fff;margin:0;">
              <b>{{ completedSteps }}</b>%
            </p>
            <p style="color:#fff;margin:0;margin-top:5px;">
              FTR
            
            </p>
          </radial-progress-bar>
        </div> -->
        <div class="md-layout-item md-size-5 vl" style="padding:0;margin-right:-25px !important;"></div>
        <div class="md-layout-item md-size-25" style="text-align:center;">
          <p style="margin:0; margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">date_range</md-icon> -->
          </p>
          <p style="margin:0;margin-top:10px;">{{this.visitCount}} Visits</p>
          <!-- <p style="margin:0;margin-top:5px;">0 min</p> -->
        </div>
        <div class="md-layout-item md-size-25" style="text-align:center;">
          <p style="margin:0;margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">timeline</md-icon> -->
          </p>
          <!-- <p style="margin:0;margin-top:10px;">{{ visitkms }} kms</p> -->
          <!-- <p style="margin:0;margin-top:5px;">{{visitmin}} min</p> -->
        </div>
        <div class="md-layout-item md-size-20" style="text-align:center;">
          <p style="margin:0;margin-top:10px;">
            <!-- <md-icon style="color: #CFD8DC;">business</md-icon> -->
          </p>
          <!-- <p style="margin:0;margin-top:10px;">Office</p> -->
          <!-- <p style="margin:0;margin-top:5px;">0 min</p> -->
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          

                <CCol col="6" md="12" style="height:600px; overflow: scroll;">
                  
                        <!-- <button @click="isShowing ^= true">Click Me</button> -->
                        <CCard class="clr"  >
                           <CCardBody>
              <CForm>
                <CInput label="Animal Id" horizontal autocomplete="name" v-model="animalId" />
<CInput label="Animal Name" horizontal autocomplete="name" v-model="animalName" />
                <!-- <CInput label="First Name" horizontal autocomplete="name" v-model="firstName" />
                <CInput label="	
Middle Name" horizontal autocomplete="name" v-model="middleName" />
                <CInput label="	
Last Name
" horizontal autocomplete="name" v-model="lastName" />

     
                <CInput label="Address" horizontal autocomplete="name" v-model="address" /> -->
                <div class="row">
  <div class="col-sm-4">society</div>
  <div class="col-sm-8">     <Vselect :options="societyoption" v-model="society"   searchable />
</div>
</div>              
<br>
 <div class="row">
  <div class="col-sm-4">Owner</div>
  <div class="col-sm-8">     <Vselect :options="farmernamelist"  v-model="ownerName" searchable />
</div>
</div>              
<br>
 <div class="row">
  <div class="col-sm-4">Birth Date</div>
  <div class="col-sm-8">      <CInput
                
                type="date"
                horizontal
                v-model="dateOfBirth"
              /> 
</div>
</div>              
<br>
     
     <div class="row">
  <div class="col-sm-4">Registration Date</div>
  <div class="col-sm-8">     <CInput
               
                type="date"
                horizontal
                 v-model="regDate"
              />     
</div>
</div>              
<br>

                  
<div class="row">
  <div class="col-sm-4">Sex</div>
  <div class="col-sm-8"> 
        <input type="radio" id="male"  v-model="sex" name="gender" value="male">
  <label for="male">Male</label><br>
  <input type="radio" id="female" v-model="sex" name="gender" value="female">
  <label for="female">Female</label><br>
</div>
</div>              
<br>
<div class="row">
  <div class="col-sm-4">Species</div>
  <div class="col-sm-8"> <Vselect :options="specieslist" v-model="species" searchable /></div>
</div>
<br>
   <div class="row">
  <div class="col-sm-4">Breed</div>
  <div class="col-sm-8">   <Vselect :options="breednamelist" v-model="breedName" searchable /></div>
</div>            
<br>
              
<div class="row">
  <div class="col-sm-4">Farm Breed</div>
  <div class="col-sm-8">   <Vselect :options="second" searchable />
</div>
</div> 
<br>
<!-- <div class="row">
  <div class="col-sm-4">Union</div>
  <div class="col-sm-8">   <Vselect :options="second" searchable />
</div>
</div> 

<br>
<div class="row">
  <div class="col-sm-4">Route</div>
  <div class="col-sm-8">   <Vselect :options="routeoption" searchable />
</div>
</div>
<br>
 
               

              
                <CInput label="SAP Code" horizontal autocomplete="name" v-model="SAPCode" />
                <CInput label="Email" horizontal autocomplete="name" v-model="email" />

                <CInput
                  label="Phone No"
                  horizontal
                  autocomplete="phoneNumber"
                  v-model="phoneNumber"
                />

                <CInput
                  label="No Of Animal Registered"
                  horizontal
                  autocomplete="name"
                  v-model="noOfAnimimalRegistered"
                />
                <CRow>
                  <CCol sm="3">
                    <h5 style="font-size:15px">Status</h5>
                  </CCol>
                  <CCol sm="3">
                    <CSwitch
                      class="mx-1"
                      color="primary"
                      v-model="suspend"
                      checked
                      variant="opposite"
                      style="width:50px;float:left !important"
                      shape="pill"
                      v-bind="labelTxt"
                    />

                  </CCol>
                </CRow> -->
              </CForm>
            </CCardBody>
            <CCardFooter>
              <CButton color="info" style="width:100px" v-if="addButton" @click="addSociety">
                <CIcon name="cilPencil" />&nbsp;Add
              </CButton>&nbsp;
              <CButton color="success" style="width:100px" v-if="saveButton" @click="updateRoute">
                <CIcon name="cilCheck" />&nbsp;Save
              </CButton>&nbsp;
              <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteRoute">
                <CIcon name="cilXCircle" />&nbsp;Delete
              </CButton>&nbsp;
              <CButton
                color="success"
                style="width:100px"
                v-if="EditsaveButton"
                @click="addSociety"
              >
                <CIcon name="cilCheck" />&nbsp;Save
              </CButton>&nbsp;
              <CButton
                color="secondary"
                style="width:100px"
                v-if="cancelButton"
                @click="CancelRoute"
              >
                <CIcon name="cilWarning" />&nbsp;Cancel
              </CButton>&nbsp;
              <CButton color="info" v-if="addnewButton" @click="addRouteplus">
                <CIcon name="cilPencil" />&nbsp;Add New
              </CButton>
            </CCardFooter>
                        </CCard>
                      </CCol>
        </div>
        <div class="md-layout-item md-size-50">
          <md-datepicker v-model="todayDate" />
        </div>
      </div>

     
    </div>
  </div>
</div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import { RadialProgressBar, TimeLine, TimeLineItem } from "@/components";
import CTableWrapper from "../../tables/Table";
import Swal from "sweetalert2";
import Dropdown from "vue-simple-search-dropdown";
import { Vselect } from "@/components";
import { APIService } from "../../../apiservice.js";
export default {
  components: {
    VuePerfectScrollbar,
    RadialProgressBar,
    TimeLine,
    TimeLineItem,
    Vselect
  },
  data() {
    return {
        tabs: [
        'Animal',
        'Service',
        
      ],
       isConfigOpen: false,
      animalItem:[],
      routeItem: [],
      societyItem: [],
      districtsItem: [],
      routenamelist:[],
      unionnamelist:[],
      second: [],
      unionoption: [],
      Stateoptions: [],
      Districtoptions: [],
      Casteoptions: [],
      routeoption: [],
      societyoption: [],
      ownerItem: [],
      owneredit: [],
      farmernamelist:[],
      specieslist:[],
      breednamelist:[],
      breedname:[],
      breedItem:[],
      animalId: null,
      animalName: "",
      society: "",
      ownerName: "",
      dateOfBirth: "",
      regDate: "",
      sex: "",
      species: "",
      breedName: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,

      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      fields: [
        {
          key: "animalId",
          sortable: true
        },
          {
          key: "animalName",
          sortable: true
        },
        {
          key: "societyName",
          sortable: true
        },
          {
          key: "unionName",
          sortable: true
        },
          {
          key: "routeName",
          sortable: true
        },
        {
          key: "ownerName",
          sortable: true
        },
        {
          key: "dateOfBirth",
          sortable: true
        },
        {
          key: "regDate",
          sortable: true
        },
        {
          key: "sex",
          sortable: true
        },
        {
          key: "speciesName",
          sortable: true
        },
        {
          key: "breedName",
          sortable: true
        },

        // {
        //   key: "Farm Breed",
        //   sortable: true
        // },
        // {
        //   key: "suspend",
        //   sortable: true
        // }
      ]

    };
  },
  methods: {

    toggleConfig(className) {
      const el = document.body;
      this.isConfigOpen = !this.isConfigOpen;
      if (this.isConfigOpen) {
        el.classList.add(className);
      }
       else {
        el.classList.remove(className);
      }
    },
     getunionList() {
      APIService.unionList().then(res => {
        if (res.status == 200) {
          this.unionItem = res.data;
          // console.log("test1", this.unionItem);

          let value = this.unionItem.map(n => {
            return n.unionName;
          });

          this.second = value;
          // console.log("valuse", value);

          // for (let i in this.unionItem) {
          //   // this.unionoption.push(this.unionItem[i].unionName)
          //   // this.second.push(this.unionItem[i].unionName);
          //   console.log("test2", this.unionItem[i].unionName);
          //   this.second.push(this.unionItem[i].unionName);
          // }
          // console.log("test2",this.second)
        }
      });
    },
    getdistrictsList() {
      APIService.districtsList().then(res => {
        if (res.status == 200) {
          this.districtsItem = res.data;
          let value = this.districtsItem.map(n => {
            return n.districtName;
          });

          this.Districtoptions = value;
          // console.log("valuse", value);
        }
      });
    },
    getSocietyList() {
      let sus = [];
      APIService.societyList().then(res => {
        if (res.status == 200) {
          this.societyItem = res.data;
          let value = this.societyItem.map(n => {
            return n.soceityName;
          });

          this.societyoption = value;
          // console.log("valuse", value);
        }
      });
    },
    getRouteList() {
      APIService.routeList().then(res => {
        if (res.status == 200) {
          this.routeItem = res.data;
          // console.log("check",routeItem.suspend)
          let value = this.routeItem.map(n => {
            return n.routeName;
          });

          this.routeoption = value;
          // console.log("valuse", value);
        }
      });
    },
    getFarmerList() {
      APIService.farmerList().then(res => {
        if (res.status == 200) {
          this.ownerItem = res.data;
          // console.log("check2", this.ownerItem);
             let value = this.ownerItem.map(n => {
            return n.firstName;
          });

          this.farmernamelist = value;
          // console.log("valuse", value);


            let value1 = this.ownerItem.map(n => {
            return n.unionName;
          });

          this.unionnamelist = value1;
          // console.log("valuse", value1);

           let value2 = this.ownerItem.map(n => {
            return n.routeName;
          });

          this.routenamelist = value2;
          console.log("valuse", value2);

        }
      });
    },
     getBreedList() {
      APIService.breedList().then(res => {
        if (res.status == 200) {
          this.breedItem = res.data;
           let value = this.breedItem.map(n => {
            return n.species;
          });

          this.specieslist = value;

           let value1 = this.breedItem.map(n => {
            return n.breedName;
          });

          this.breednamelist = value1;
          // console.log("valuse", value);
        }
      });
    },    
       getanimalList() {
      APIService.animalList().then(res => {
        if (res.status == 200) {
          this.animalItem = res.data;
         
           this.animalId = this.animalItem[0].animalId;
      this.animalName = this.animalItem[0].animalName;
      this.society = this.animalItem[0].society;
      this.ownerName = this.animalItem[0].ownerName;
      this.dateOfBirth = this.animalItem[0].dateOfBirth;
      this.regDate = this.animalItem[0].regDate;
      this.sex = this.animalItem[0].sex;
      this.species = this.animalItem[0].species;
      this.breedName = this.animalItem[0].breedName;

        }
      });
    },
    
    
    
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.owneredit = item;
      this.animalId = item.animalId;
      this.animalName = item.animalName;
      this.society = item.society;
      this.ownerName = item.ownerName;
      this.dateOfBirth = item.dateOfBirth;
      this.regDate = item.regDate;
      this.sex = item.sex;
      this.species = item.species;
      this.breedName = item.breedName;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;

      return this.toggleConfig('settings-open');
    },
    addSociety() {
      let animalId = this.animalId;
      let animalName = this.animalName;
      let society = this.society;
      let ownerName = this.ownerName;
      let dateOfBirth = this.dateOfBirth;
      let regDate = this.regDate;
      let sex = this.sex;
      let species = this.species;
      let breedName = this.breedName;
      // let suspend = this.suspend;
      let data = {
      animalId,
        animalName,
        society,
        ownerName,
        dateOfBirth,
        regDate,
        sex,
        species,
        breedName,
        // noOfAnimimalRegistered,
        // suspend
      };
      APIService.saveAnimal(data).then(res => {
        if (res.status == 200) {
          this.animalId = null;
          this.animalName = "";
          this.society = "";
          this.ownerName = "";
          this.dateOfBirth = "";
          this.regDate = "";
          this.sex = "";
          this.species = "";
          this.breedName = "";
         
         this.getanimalList();
           Swal.fire({
  position: 'top-end',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
      this.animalId = null;
          this.animalName = "";
          this.society = "";
          this.ownerName = "";
          this.dateOfBirth = "";
          this.regDate = "";
          this.sex = "";
          this.species = "";
          this.breedName = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getanimalList();
    },

    CancelRoute() {
      this.animalId = null;
          this.animalName = "";
          this.society = "";
          this.ownerName = "";
          this.dateOfBirth = "";
          this.regDate = "";
          this.sex = "";
          this.species = "";
          this.breedName = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getanimalList();
    },
    updateRoute() {
      let id = this.owneredit._id;
       let animalId = this.animalId;
      let animalName = this.animalName;
      let society = this.society;
      let ownerName = this.ownerName;
      let dateOfBirth = this.dateOfBirth;
      let regDate = this.regDate;
      let sex = this.sex;
      let species = this.species;
      let breedName = this.breedName;
      let value = {
       animalId,
        animalName,
        society,
        ownerName,
        dateOfBirth,
        regDate,
        sex,
        species,
        breedName
      };
      let data = { id, value };
      APIService.animalUpdate(data).then(res => {
        if (res.status == 200) {
          this.animalId = null;
          this.animalName = "";
          this.society = "";
          this.ownerName = "";
          this.dateOfBirth = "";
          this.regDate = "";
          this.sex = "";
          this.species = "";
          this.breedName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getanimalList();
          Swal.fire({
  position: 'top-end',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {

      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  },
     delete(){
        let id = this.owneredit._id;
      let data = { id };
      APIService.animalDelete(data).then(res => {
        if (res.status == 200) {
          this.animalId = null;
          this.animalName = "";
          this.society = "";
          this.ownerName = "";
          this.dateOfBirth = "";
          this.regDate = "";
          this.sex = "";
          this.species = "";
          this.breedName = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getanimalList();
        }
      });
    }

  },
  created() {
    this.getFarmerList();
    this.getunionList();
    this.getdistrictsList();
    this.getSocietyList();
    this.getRouteList();
    this.getBreedList();
    this.getanimalList();
      this.isConfigOpen = true;
    this.toggleConfig("settings-open");
  }
  
};
</script>
 <style lang="scss" scoped>
.scrollbar-container1 {
  position: relative;
  height: 100%;
}
.btn-warning {
  color: #fff;
  // background-color: #425276;
  border-color: #425276;
}
.btn {
  font-size: 0.94rem;
  font-weight: 500;
}

$theme-options-width: 500px;

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate($theme-options-width);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(darken(#007bff, 50%), 0.03),
    -0.9375rem 0 1.40625rem rgba(darken(#007bff, 50%), 0.03),
    -0.25rem 0 0.53125rem rgba(darken(#007bff, 50%), 0.05),
    -0.125rem 0 0.1875rem rgba(darken(#007bff, 50%), 0.03);

  .btn-open-options {
    border-radius: 50px;
    position: absolute;
    left: -100px;
    bottom: 40px;
    padding: 0;
    height: auto;
    line-height: 50px;
    width: 54px;
    text-align: center;
    display: block;
    box-shadow: 0 0.46875rem 2.1875rem rgba(darken(#007bff, 50%), 0.03),
      0 0.9375rem 1.40625rem rgba(darken(#007bff, 50%), 0.03),
      0 0.25rem 0.53125rem rgba(darken(#007bff, 50%), 0.05),
      0 0.125rem 0.1875rem rgba(darken(#007bff, 50%), 0.03);
    margin-top: -27px;

    svg {
      top: 50%;
      left: 50%;
      color: white;
      position: absolute;
      margin: -0.5em 0 0 -0.5em;
    }
  }

  .theme-settings__inner {
    background: #f1f1f1;
    width: $theme-options-width;
    height: 100vh;
    padding: 0;
  }

  .theme-settings-swatches {
    text-align: center;

    .swatch-holder-img {
      width: 72px;
      height: auto;
      border-radius: 3px;

      img {
        width: 100%;
      }
    }
  }

  .themeoptions-heading {
    font-size: (1rem * 1.25);
    color: gray;
    margin: 0;
    background: gray;
    padding: (1.5rem / 2) 1.5rem;
    border-bottom: gray solid 1px;
    border-top: gray solid 1px;
    display: flex;
    align-items: center;
    align-content: center;

    &:first-child {
      border-top: 0;
    }
  }

  .list-group-item {
    h5 {
      color: #007bff;
      font-size: (1rem * 0.875);
      text-transform: uppercase;
      margin: 0;
      text-align: center;
    }
  }
}

.settings-open {
  .ui-theme-settings {
    transform: translate(0);
    right: 0;

    .btn-open-options {
      left: -80px;
    }
  }
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;

  &.active {
    border: #fff solid 2px;
    box-shadow: 0 0 0 5px #007bff;
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.swatch-holder-md {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.vl {
  border-left: 1px solid black;
  height: auto;
}
</style>

<style >
.timeline.timeline-simple {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.timeline > li {
  margin-bottom: 0px !important;
}
.timeline.timeline-simple:before {
  height: 100%;
}

.lastknown .timeline.timeline-simple:before {
  display: none;
  /* height: 50%; */
}

.badgeVisit {
  border: 2px solid rgb(76, 175, 80);
  color: #000000;
  font-size: 11px;
}
.badgePunchIn {
  border: 2px solid rgb(244, 67, 54);
  color: #000000;
  font-size: 11px;
}

.badgePunchOut {
  border: 2px solid rgb(244, 67, 54);
  color: #000000;
  font-size: 11px;
}
.badgeLastKnown {
  border: 2px solid rgb(0, 188, 212);
  color: #000000;
  font-size: 11px;
}
</style>